import { ReactNode, useEffect, useState } from "react";
import { HelperState } from "../HelperState";
import { useHelperStore } from "../HelperStore";

export function ClearHelpers(props:{children:ReactNode, openHelpers?:string[]}){
    const [helpersCleared, setHelpersCleared] = useState<boolean>(false)
    const openHelpers:string[] = (props.openHelpers) ? props.openHelpers :[]
    const openHelpersByTitle:Function =  useHelperStore((state:HelperState)=>state.openOnlyHelpersByTitle)
    const clearHelpers = () => {
        if(!helpersCleared){
            setHelpersCleared(true)
            openHelpersByTitle(openHelpers)
        }
    }
    useEffect(()=>{
        clearHelpers()}
    )
    return(<>{props.children}</>)
}